<template>
  <button @click="checkFunction" type="submit">{{ ButtonText }}</button>
</template>

<script>
export default {
  name: "Button",
  data() {
    return {
      ButtonText: "",
    };
  },
  methods: {
    checkFunction() {
      if (this.buttonText === "Detail") {
        this.$emit("getFoodDetail");
      } else if (this.buttonText === "Edit") {
        this.$emit("goToFormEdit");
      }
    },
  },
  props: ["buttonText"],
  created() {
    switch (this.buttonText) {
      case "Login":
        this.ButtonText = this.buttonText;
        break;
      case "Sign Up":
        this.ButtonText = this.buttonText;
        break;
      case "Detail":
        this.ButtonText = this.buttonText;
        break;
      case "Edit":
        this.ButtonText = this.buttonText;
        break;
      case "submitFood":
        this.ButtonText = "Submit";
        break;
      default:
        break;
    }
  },
};
</script>

<style>
</style>